import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DEFAULT_PERSON_AVATAR } from '../Constants';
import useAuth from '../hooks/AuthHook.jsx';
import { getMissingCredentials } from '../../helpers/CredentialUtils.js';
import './LocumNavigationSidebar.scss';

export const LOCUM_NAVIGATION_BUTTONS = {
  ALL: { buttonText: 'Schedule', path: '/locum/shifts', mode: 'ALL'},
  PROFILE: { buttonText: 'Profile', path: '/locum/profile/edit', mode: 'PROFILE' },
  PAYMENTS: { buttonText: 'Payments', path: '/locum/payments/manage', mode: 'PAYMENTS' },
  ACCOUNT: { buttonText: 'Account', path: '/locum/account/manage', mode: 'ACCOUNT' },
  LOGOUT: { buttonText: 'Logout', path: '/', mode: 'LOGOUT'}
}

export const LocumNavigationSidebar = ({ currentMode }) => {
  const { profile, logout } = useAuth();

  const { firstName, lastName, avatar, address } = profile;
  const { suburb, state } = address;
  const navigate = useNavigate();

  const navigationList = Object.keys(LOCUM_NAVIGATION_BUTTONS).map(mode => {
    const nav = LOCUM_NAVIGATION_BUTTONS[mode];
    const { buttonText, path } = nav;
    const buttonClick = () => navigate(path);
    const active = mode === currentMode;
    const activeClass = active ? 'active' : '';
    const logoutClick = () => {
      navigate('/', { replace: true });
      logout();
    };

    if (mode === 'PAYMENTS') {
      return (
        <>
          <li className={'locum-navigation-item'} key={mode}>
            <button className={`locum-navigation very-light ${activeClass}`} onClick={buttonClick} disabled={active}>
              {buttonText}
            </button>
          </li>
          <div className={'divider'}></div>
        </>
      )
    } else if (mode === 'LOGOUT') {
      return (
        <li className={'locum-navigation-item'} key={mode}>
          <button className={`locum-navigation very-light ${activeClass}`} onClick={logoutClick} disabled={active}>
            {buttonText}
          </button>
        </li>
      )
    } else {
      return (
        <li className={'locum-navigation-item'} key={mode}>
          <button className={`locum-navigation very-light ${activeClass}`} onClick={buttonClick} disabled={active}>
            {buttonText}
          </button>
        </li>
      )
    }
  });

  // ABN, AHPRA and PII are managed on the account page; the sidebar only nudges when something is missing.
  const hasMissingCredentials = getMissingCredentials(profile).length > 0;
  const profileAvatar = avatar ? avatar : DEFAULT_PERSON_AVATAR;
  return (
    <aside className={'locum-sidebar'}>
      <section className={'locum-image-and-name'}>
        <section className={'locum-image-container'}>
          <img className={'locum-image'} src={profileAvatar} alt={'Profile Avatar'} />
        </section>
        <h2 className={'locum-sidebar-name'}>
          {`${firstName} ${lastName}`}
        </h2>
        <div className={'locum-sidebar-address'}>{`${suburb}, ${state}`}</div>
        {hasMissingCredentials &&
          <button className={'credentials-nudge'} onClick={() => navigate(LOCUM_NAVIGATION_BUTTONS.ACCOUNT.path)}>
            {'Complete your details'}
          </button>
        }
      </section>
      <ul className={'locum-navigation-list'}>
        {navigationList}
      </ul>
    </aside>
  );
};

export default LocumNavigationSidebar;
